import { Directive, ElementRef, HostListener, Input, Output, EventEmitter, OnInit, HostBinding, Renderer2, OnDestroy } from '@angular/core';
import {BehaviorSubject } from 'rxjs/BehaviorSubject';
import {IScrollbarXProps, IScrollbarYProps } from './multiplane-grid.directive'
import { NGXLogger } from 'ngx-logger';

@Directive({ selector: '[app-multiplane]' })
export class MulitplaneGridDirective {

        startX:number = 0;
        startY = 0;
        x=0;
        y=0;

        accelerationTimer = null;
        accelerationDelay = null;
        speed = 0.5;
        speedX = 1;
        speedY = 1;
        dragging = false;

        content;
        header;
        top;
        corner;
        inner;
        child;
        yScrollbar;
        yBar;
        xScrollbar;
        xBar;

        xMouseMoveBind;
        xMouseUpBind;

        yMouseMoveBind;
        yMouseUpBind;

        scrollYProps = {
                      top: 0,
                      height: 30,
                      opacity: 1
                    };

        scrollXProps = {
                      left: 0,
                      width: 30,
                      opacity: 1
                  };

        topOffset = 0;


    constructor(private elem: ElementRef, private renderer: Renderer2, private logger:NGXLogger) {
    }

    @HostListener('mousewheel', ['$event']) onMousewheel(event) {
        this.mousewheel(event);
    }

    @HostListener('mouseover',['$event'])
    onMouseOver(event) {
      this.renderer.addClass(this.yScrollbar, 'active');
      this.renderer.addClass(this.xScrollbar, 'active');
    }

    @HostListener('mouseout')
    onMouseOut() {
      this.renderer.removeClass(this.yScrollbar, 'active');
      this.renderer.removeClass(this.xScrollbar, 'active');
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
      this.logger.debug('resize')
      this.resize();
    }


    ngAfterViewInit() {
        this.content = this.elem.nativeElement.querySelector('.xy-content');
        this.header = this.elem.nativeElement.querySelector('.xy-header-left');
        this.top = this.elem.nativeElement.querySelector('.xy-header-top');
        this.corner = this.elem.nativeElement.querySelector('.xy-corner');
        this.inner = this.elem.nativeElement.parentElement; //element.find('.xy-inner'),
        this.child = this.elem.nativeElement.children;
        this.yScrollbar = this.elem.nativeElement.querySelector('.xy-scroll-y');
        this.xScrollbar = this.elem.nativeElement.querySelector('.xy-scroll-x');
        this.yBar = this.elem.nativeElement.querySelector('.xy-bar-y');
        this.xBar = this.elem.nativeElement.querySelector('.xy-bar-x');

        this.child = this.content.querySelector('table.fixed');

        setTimeout(val=>{
          this.setup();
          this.resize();
        },50)
    }

    setup() {

        this.logger.debug(this.child)

        this.yBar.addEventListener('mousedown', this.beginDragY.bind(this));
        this.xBar.addEventListener('mousedown', this.beginDragX.bind(this));

        this.xScrollbar.addEventListener('mouseover', this.hoverXScrollbar.bind(this));
        this.xScrollbar.addEventListener('mouseout', this.outXScrollbar.bind(this));

        this.yScrollbar.addEventListener('mouseover', this.hoverYScrollbar.bind(this));
        this.yScrollbar.addEventListener('mouseout', this.outYScrollbar.bind(this));


        this.xMouseMoveBind = this.dragX.bind(this);
        this.xMouseUpBind = this.endDragX.bind(this);

        this.yMouseMoveBind = this.dragY.bind(this);
        this.yMouseUpBind = this.endDragY.bind(this);
    }

    hoverXScrollbar (event) {
      event.preventDefault();
      this.xBar.style.height = '12px';
      this.xBar.style.top = '18px';
    }
    outXScrollbar (event) {
      event.preventDefault();
      this.xBar.style.height = '6px';
      this.xBar.style.top = '';
    }

    hoverYScrollbar (event) {
      event.preventDefault();
      this.yBar.style.width = '12px';
      this.yBar.style.left = '18px';
    }
    outYScrollbar (event) {
      event.preventDefault();
      this.yBar.style.width = '6px';
      this.yBar.style.left = '';
    }

    resize() {
           //top header
           this.topOffset = this.getTopOffset();
           this.corner.style.height = this.topOffset + 'px';
           this.top.style.height = this.topOffset + 'px';

           //scrollbar
           this.scrollXProps.width = this.getScrollWidth();
           this.scrollYProps.height = this.getScrollHeight();
           this.speedX = this.getRatioX();
           this.speedY = this.getRatioY();

           //set position
           this.scrollX();
           this.scrollY();

           // update the scrollbar dom
           this.xBar.style.width = this.scrollXProps.width + 'px';
           this.yBar.style.height = this.scrollYProps.height + 'px';

           if(this.scrollYProps.height >= this.actualHeight()){
             this.yBar.style.display = 'none';
           }else{
             this.yBar.style.display = 'block';
           }

           if(this.scrollXProps.width >= this.actualWidth()){
             this.xBar.style.display = 'none';
           }else{
             this.xBar.style.display = 'block';
           }
           this.logger.debug(this.getScrollHeight(), this.scrollYProps, this.actualHeight())

    }

      beginDragX (event) {
        event.preventDefault();
        this.dragging = true;
        this.startX = event.pageX;
        document.addEventListener('mousemove', this.xMouseMoveBind);
        document.addEventListener('mouseup', this.xMouseUpBind);
      }

      beginDragY(event) {
        event.preventDefault();
        this.dragging = true;
        this.startY = event.pageY;
        document.addEventListener('mousemove', this.yMouseMoveBind);
        document.addEventListener('mouseup', this.yMouseUpBind);
      }

      dragX(event) {
        event.preventDefault();

        let delta = event.pageX - this.startX;
        this.startX += delta;

        this.moveX(delta * this.speedX);
        this.update();
      }

      dragY(event) {
        event.preventDefault();

        let delta = event.pageY - this.startY;
        this.startY += delta;
        this.moveY(delta * this.speedY);
        this.update();
      }

      endDragX(e) {
        this.dragging = false;

        document.removeEventListener('mousemove', this.xMouseMoveBind );
        document.removeEventListener('mouseup', this.xMouseUpBind );
      }

      endDragY(e) {
        this.dragging = false;
        //scope.$apply();
        document.removeEventListener('mousemove', this.yMouseMoveBind);
        document.removeEventListener('mouseup', this.yMouseUpBind);
      }


    mousedown(event) {
           // Prevent default dragging of selected content
           event.preventDefault();
           this.startX = event.pageX - this.x;
           this.startY = event.pageY - this.y;

           document.addEventListener('mousemove',this.mousemove.bind(this));
           document.addEventListener('mouseup',this.mouseup.bind(this));
            // this.renderer.listen('document', 'mousemove', (event) => {
            //   this.mousemove();
            // });
            // this.renderer.listen('document', 'mouseup', (event) => {
            //   this.mouseup();
            // });

         }

    mousemove(event) {
       event.preventDefault();
       if (this.dragX) {
         this.x = this.limitX(event.pageX - this.startX);
         this.scrollX();
       }
       if (this.dragY) {
         //this.logger.debug(event.pageY, this.startY);
         this.y = this.limitY(event.pageY - this.startY);
         this.scrollY();
       }
       this.update();
     }

     mouseup() {
       // $document.off('mousemove', mousemove);
       // $document.off('mouseup', mouseup);
     }

    mousewheel(event) {
        event.preventDefault();
        //this.logger.debug('in mousewheel');
        // support non-webkit browsers
        if (event.originalEvent != undefined) {
          event = event.originalEvent;
        }
        var delta = this.getWheelDelta(event); // event.wheelDeltaY || event.wheelDelta;
        delta = Math.floor(delta * this.accelerate());
        // shift or cmd(Mac) is pressed?

        //this.logger.debug(delta,'delta')
        if (event.shiftKey || event.metaKey) {
          this.moveX(-delta);
        } else {
          this.moveY(-delta);
        }
        this.update();
      }

      getWheelDelta(event) {
         let val = 0;
         if (event.type == "wheel" || event.deltaY) {
           var delta = event.deltaX || event.deltaY;
           val = (event.deltaMode == 0) ? -delta : -delta * 40; //line mode
         }
         if (event.type == "mousewheel") {
           val = event.wheelDeltaY || event.wheelDelta;
         }
         return val;
      }

      /** acceleration effect on mouse wheel */
      accelerate():number {


        if (this.accelerationTimer) {
          //keep moving state
          //$timeout.cancel(this.accelerationTimer);
          if (this.accelerationDelay) {
            //keep acceleration
            clearTimeout(this.accelerationTimer);
          }
          this.accelerationDelay = setTimeout(function() {
            this.speed += 0.1; //increase speed every 0.2s
          }, 200);
        }

        this.accelerationTimer = setTimeout(function() {
          this.speed = 0.5;
        }, 400);

        return Math.min(this.speed, 1);
      }


      update() {
         this.x = this.x;
         //this.y = 200;
         this.scrollXProps.left = this.getBarPositionX();
         this.scrollYProps.top = this.getBarPositionY();

         // update the scroll bar positions
         this.yScrollbar.style.top = this.scrollYProps.top + 'px';
         this.xScrollbar.style.left = this.scrollXProps.left + 'px';

      }

      moveX(distance) {
             this.x = this.limitX(this.x - distance);
             this.scrollX();
      }

      moveY(distance) {
           //this.logger.debug(distance, ' distance', this.y)
           this.y = this.limitY(this.y - distance);
           this.scrollY();
      }

      limitX(value) {
        //value is negative
        var limit = this.maxX();
        return Math.min(0, Math.max(-limit, value));
      }

      limitY(value) {
        var limit = this.maxY();
        return Math.min(0, Math.max(-limit, value));
      }

      maxX() {
        var limit = this.actualWidth() - this.content.offsetWidth;
         //this.logger.debug('actualWidth:',this.actualWidth(),' limit:',limit, ' innner.width:',this.content.offsetWidth)
        return limit;
      }

      maxY() {
        let viewHeight = this.elem.nativeElement.offsetHeight;
        var height = this.actualHeight();
        //let height = this.content.offsetHeight+200;
        return height - viewHeight;
      }

      getTopOffset() {
        //this.logger.debug(this.top.children[0].offsetHeight)
        return Math.max(this.top.offsetHeight, this.corner.offsetHeight);
      }

      getBarPositionX() {
        var viewWidth = this.content.offsetWidth;
        var barSize = this.scrollXProps.width;
        var max = viewWidth - barSize;
        var xMax = this.maxX();
        var ratio = -this.x / xMax;
        //this.logger.debug('viewWidth:',viewWidth,' barsize:',barSize,' max:',max,' xMax:',xMax,' ratio:',ratio)
        return Math.floor(ratio * max);
      }

      getBarPositionY() {
        var height = this.elem.nativeElement.offsetHeight;
        var barSize = this.scrollYProps.height;
        var offset = this.topOffset;
        var max = height - barSize - offset;
        var yMax = this.maxY();
        var ratio = -this.y / yMax;

        //this.logger.debug(ratio, max, ' bar y pos')
        return Math.floor(ratio * max);
      }

      getScrollWidth() {
        var w = this.content.offsetWidth; //.xy-inner width
        var len = this.actualWidth();
        //this.logger.debug(w,len)
        return w * w / len;
      }

      getScrollHeight() {
        var h = this.elem.nativeElement.offsetHeight - this.top.offsetHeight;
        //var len = this.actualHeight();
        let len = this.content.offsetHeight;

        return h * h / len;
      }

      getRatioX() {
        var viewLength = this.content.offsetWidth;
        //var actualLength = this.actualWidth();
        let actualLength = this.actualWidth();
        return actualLength / viewLength;
      }

      getRatioY() {
        var viewLength = this.elem.nativeElement.offsetHeight - this.top.offsetHeight;
        var actualLength = this.content.offsetHeight;
        return actualLength / viewLength;
      }

      scrollX() {
        var pos = {
          left: this.x + 'px'
        };
        this.top.style.left = this.x + 'px';
        this.content.style.left = this.x + 'px';
      }

      scrollY() {
        var yOffset = this.y + this.topOffset; //left header
        // this.header.css({
        //   top: yOffset + 'px'
        // });
        // this.content.css({
        //   top: this.y + 'px'
        // });

        this.header.style.top = yOffset + 'px';
        this.content.style.top = this.y + 'px';

      }

      actualHeight() {
        var h = this.child.offsetHeight;
        return h + this.topOffset;
      }

      actualWidth() {
        var h = this.top.offsetWidth;
        var w = this.child.offsetWidth;
        return Math.max(h, w);

      }

}

export interface IScrollbarXProps{
  left: number;
  width: number;
  opacity: number;
}

export interface IScrollbarYProps{
  top: number;
  height: number;
  opacity: number;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/directives/multiplane-grid.directive.ts